//时间格式：10分钟前/1小时前/今天12:22/昨天12:22/前天12:22
import {
  SourceType as ST,
  SKButtonStatus as BS,
  ShakeEvent as SE,
  Config
} from '../../../apis/enums.js';
import { FLIB } from '../../../apis/index.js';

export const Button = {
  [BS.STATUS_NOT_OPEN]: {
    status: BS.STATUS_NOT_OPEN,
    desc: '去实现',
    type: 'strong',
    button_action: `jump_url`,
    button_params: ''
  },
  [BS.STATUS_NOT_RECEIVED]: {
    status: BS.STATUS_NOT_RECEIVED,
    desc: '领取',
    type: 'strong',
    button_action: 'getGift'
  },
  [BS.STATUS_RECEIVED]: {
    status: BS.STATUS_RECEIVED,
    desc: '查看',
    type: 'default',
    button_action: 'jump_url'
  },
  [BS.STATUS_EXPIRESED]: {
    status: BS.STATUS_EXPIRESED,
    desc: '已过期',
    type: 'disable',
    button_action: 'showExpires'
  },
  [BS.STATUS_VIEW_DETAIL]: {
    status: BS.STATUS_VIEW_DETAIL,
    desc: '查看',
    type: 'default',
    button_action: 'jump_url'
  }
};

function getFeedInfo(item, realize_by_self) {
  let title = '';
  // 预约礼包填写获得
  let is_ss = `${SE[item.event]}`.includes('SMALL_GIFT');
  let wishSet = new Set([
    SE.EVENT_MY_WISH_HIGH,
    SE.EVENT_MY_WISH_MID,
    SE.EVENT_MY_WISH_LOW,
    SE.EVENT_FRIEND_WISH,
    SE.EVENT_GLOBAL_WISH
  ]);
  let rwdMap = new Map([
    [SE.EVENT_CASH_1, '现金红包'],
    [SE.EVENT_CASH_2, '现金红包'],
    [SE.EVENT_CASH_3, '现金红包'],
    [SE.EVENT_CASH_4, '现金红包'],
    [SE.EVENT_SMALL_REWARD, '游戏道具'],
    [SE.EVENT_APPOINT_SMALL_CARD, '预约礼包'],
    [SE.EVENT_APPOINT_CARD, '预约礼包']
  ]);
  let rwtMap = new Map([
    [ST.TYPE_GIFT, '游戏道具'],
    [ST.TYPE_CARD, '预约礼包'],
    [ST.TYPE_CASH, '现金红包'],
    [ST.TYPE_THING, '实物奖品']
  ]);
  if (item.is_owner) {
    let rtype = rwtMap.has(item.type) ? rwtMap.get(item.type) : rwtMap.get(ST.TYPE_GIFT);
    let rdesc = rwdMap.has(item.event) ? rwdMap.get(item.event) : rtype;
    title = wishSet.has(item.event)
      ? (realize_by_self ? '实现了' : '摇到了') + '游戏心愿'
      : (is_ss ? '领到了' : '摇到了') + rdesc;
  } else {
    title = `实现了心愿`;
  }
  return title;
}

function getFeedName(item, app) {
  let evt = SE[item.event] || '';
  let ret = '';
  if (!item.name || (item.status == BS.STATUS_NOT_OPEN && evt.indexOf('_WISH') != -1)) {
    ret =
      (item.app_name || app.BriefName || '游戏') +
      (SE[item.event].indexOf('_WISH') != -1
        ? item.event == SE.EVENT_GLOBAL_WISH
          ? '狂欢心愿'
          : '心愿'
        : ST[`TYPE_${item.type}`]
        ? ST[`TYPE_${item.type}`]
        : '游戏道具');
  } else {
    ret =
      item.type == ST.TYPE_CASH
        ? Number(item.cash_amount / 100).toFixed(2)
        : item.event == SE.EVENT_SMALL_REWARD
        ? item.desc || item.name
        : item.name;
  }
  return ret;
}

export function parseTime(tm) {
  return FLIB.parseTime(tm);
}

export function fillParams(item, openid, app) {
  let r = item.reward || item.record || {};
  let s = item.source_info || {};
  let o = item.owner_info || {};
  let f = item.realize_info || {};
  let a = item.app_info || {};
  // r.status = 1; // TODO: 正式发布注释掉
  // 没有实现人或者实现人头像和owner头像是同一个人
  let realize_by_self =
    item.is_owner &&
    ((f.head_img_url == o.head_img_url && f.nickname == o.nickname) || !f.nickname);
  let realize_by_other = FLIB.left(`${f.nickname || '好友'}`, 6);
  let parsed = Object.assign({}, r, s, o, a, {
    is_owner: item.is_owner || false,
    time: parseTime(r.got_timestamp),
    name_desc: '',
    prefix: item.is_owner ? (realize_by_self ? '我' : realize_by_other) : `我帮`,
    nick: item.is_owner ? (realize_by_self ? '' : '帮我') : o.nickname || '好友',
    token: r.instance_id || '',
    realize_info: f,
    openid,
    giftid: r.sourceid || 0,
    pid: 3,
    pos: 21,
    extra: {
      game_appid: r.appid,
      actid: Config.actid,
      type: r.type,
      event: r.event,
      token: r.instance_id || '',
      giftid: r.sourceid || 0,
      is_owner: item.is_owner,
      openid,
      pid: 3,
      pos: 21
    },
    // 2023 新增
    game_app_info: item.game_app_info,
    is_partition: item.is_partition
  });
  if ('event' in parsed && SE[parsed.event].indexOf('_CASH') != -1) {
    parsed.icon1 = Config.cash_icon;
    parsed.name_desc = '现金 ¥';
  }
  parsed.title = getFeedInfo(parsed, realize_by_self);
  parsed.name = getFeedName(parsed, app);

  return parsed;
}
export function getButtonInfo(item, openid) {
  let button = {
    pid: 3,
    pos: 21,
    is_owner: item.is_owner,
    opstat: 2,
    giftid: item.sourceid,
    exter: JSON.stringify({
      fri: item.is_owner ? 0 : 1
    })
  };

  let button_params = [
    'https://',
    location.hostname,
    '/cgi-bin/activity/static/shake_result/index.html?nowepkg=1&c=1&s=1',
    '&openid=' + openid,
    '&appid=' + item.appid,
    `&nav_color=FF7A5A&darkmode_nav_color=FF7A5A`,
    `&token=${item.instance_id}`,
    '#wechat_redirect'
  ].join('');

  button._type = item.type;
  button._event = item.event;
  // 是心愿
  if (
    item.type == ST.TYPE_GIFT ||
    item.type == ST.TYPE_CASH ||
    item.type == ST.TYPE_THING ||
    item.type == ST.TYPE_APPOINTMENT_GIFT ||
    item.type == ST.TYPE_WXAG ||
    item.type == ST.TYPE_CDKEY
  ) {
    if (
      item.status == BS.STATUS_NOT_RECEIVED && // 未领取到游戏或卡包
      item.is_owner
    ) {
      // 去领卡或者兑换到游戏
      Object.assign(button, Button[item.status]);
      button.opstat = 109;
      button.button_action = item.type == ST.TYPE_APPOINTMENT_GIFT ? 'send2Game' : 'getGift';
    } else {
      // 跳详情页查看
      Object.assign(button, Button[BS.STATUS_VIEW_DETAIL]);
      button.opstat = 40;
      if (item.status == BS.STATUS_NOT_OPEN && item.is_owner && item.type != ST.TYPE_THING) {
        button.desc = '开启';
        button.type = 'strong';
      }
    }
    if (!item.is_owner) {
      button.desc = item.status == BS.STATUS_NOT_OPEN ? '通知TA' : '查看';
      button.type = 'default';
      button.button_action = item.status == BS.STATUS_NOT_OPEN ? 'showShare' : 'jump_url';
    }
  } else if (item.type == ST.TYPE_RED_PACKET) {
    Object.assign(button, Button[item.status]);
    if (item.status == BS.STATUS_NOT_OPEN && item.is_owner) {
      button.desc = '开启';
      button.type = 'strong';
      button.opstat = 2;
    } else if (
      item.status == BS.STATUS_NOT_RECEIVED && // 未领取到游戏或卡包
      item.is_owner
    ) {
      // 去领卡或者兑换到游戏
      Object.assign(button, Button[item.status]);
      button.opstat = 109;
      button.desc = '领取';
      button.button_action = 'getRedpackCover';
      button.type = 'strong';
    } else {
      button.desc = '查看';
      button.type = 'default';
      button.opstat = 2;
      button.button_action = 'jump_url';
    }
    // button_params = item.red_packet_url || button_params;
  } else if (item.type == ST.TYPE_CARD) {
    // item.status = BS.STATUS_NOT_RECEIVED;
    // delete item.card_info;
    Object.assign(button, Button[BS.STATUS_RECEIVED]);
    button.opstat = 2;
  } else if (item.type == ST.TYPE_THING) {
    Object.assign(button, Button[BS.STATUS_VIEW_DETAIL]);
    button.opstat = 40;
  } else {
    Object.assign(button, Button[item.status]);
    button.opstat = 2;
  }
  // button.desc = { [button.status]: button.desc };
  return {
    ...button,
    is_owner: item.is_owner,
    btn_cls: `${button.type}_button`,
    width: '60px',
    height: '32px',
    fontSize: 13,
    openid,
    button_params
  };
}
export default {
  parseTime,
  fillParams,
  getButtonInfo
};
